export const defaultStyles = {
  backgroundColor: "transparent",
  borderRadius: {
    border_left_top_radius: 0,
    border_left_bottom_radius: 0,
    border_right_top_radius: 0,
    border_right_bottom_radius: 0,
  },
  sizing: {
    width: "138px",
    height: "auto",
    minWidth: "auto",
    minHeight: "auto",
    maxWidth: "auto",
    maxHeight: "auto",
  },
  padding: {
    paddingTop: "0",
    paddingBottom: "0",
    paddingRight: "0",
    paddingLeft: "0",
  },
  margin: {
    marginTop: "24",
    marginBottom: "12",
    marginRight: "24",
    marginLeft: "24",
  },
} as const;
